import {Component, ElementRef, EventEmitter, HostBinding, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import {BBS_CATEGORY} from "../../defines/protocol";
import {RECORDER_HELP_BBS_ID} from "../../defines/desktop.const";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {clickOutsideLinkMixin} from "../../mixin/click-outside.mixin";

@Component({
  selector: 'app-pitch-help-popup',
  templateUrl: './pitch-help-popup.component.html',
  styleUrls: ['./pitch-help-popup.component.scss']
})
export class PitchHelpPopupComponent extends clickOutsideLinkMixin implements OnInit, OnDestroy {
  @HostBinding('class') class = 'help-contents-box';
  @Output() close = new EventEmitter<boolean | null>()

  protected readonly BBS_CATEGORY = BBS_CATEGORY;
  protected readonly RECORDER_HELP_BBS_ID = RECORDER_HELP_BBS_ID;

  constructor(
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    public override globalEventSvc: GlobalEventService,
  ) {
    super(elementRef, renderer, globalEventSvc);
  }

  ngOnInit() {
    this.coInit((event: MouseEvent|TouchEvent) => {
      if (!this.elementRef.nativeElement.parentNode.contains(event.target)) {
        this.close.emit(null);
      }
    });
  }

  ngOnDestroy() {
    this.coDestroy();
  }

  /**
   * 닫기 버튼 클릭 시 호출되는 이벤트
   * @param event - 이벤트
   * @param showSaseung - 사성 표시 여부
   *  @type {boolean | null}
   *  @default null - 사성 표시 여부 변경 없음
   *  @example true - 사성 표시
   *  @example false - 사성 미표시
   */
  onClose(event: MouseEvent, showSaseung: boolean | null = null) {
    // console.log('WordHelpPopupComponent::onClose()');

    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);

    this.close.emit(showSaseung);
  }
}
